export default {
  inspectorList: () => `/inspector/list`,
  getPaySummary: (inspectorNumber, payPeriodId) => `/inspector/${inspectorNumber}/paySummary/${payPeriodId}`,
  updateFieldRep: (inspectorNumber) => `/inspector/${inspectorNumber}/update`,
  getAllTeamLeaders: () => `/inspector/teamleaders`,
  getCaseIssues: (inspectorNumber) => `/inspector/${inspectorNumber}/case-issues`,
  getMinimalInspectorList: () => `/inspector/minimal-list`,
  createInspector: () => `/inspector/create`,
  getMinimalInspectorListByCase: (controlIdNumber) => `/inspector/simple-list/case/${controlIdNumber}`,
  updateFRServiceBoundary: (inspectorNumber) => `/inspector/${inspectorNumber}/service-region`,
};
